package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class AssistantMessageQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectByConversation(conversation_id: String, mapper: (
    id: String,
    conversation_id: String,
    role: String,
    content: String,
    sources: String?,
    status: String,
    error_code: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByConversationQuery(conversation_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectByConversation(conversation_id: String): Query<Assistant_message> =
      selectByConversation(conversation_id) { id, conversation_id_, role, content, sources, status,
      error_code, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Assistant_message(
      id,
      conversation_id_,
      role,
      content,
      sources,
      status,
      error_code,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectLastAnswers(skill_id: String, mapper: (
    conversation_id: String,
    content: String,
    created_at: Long,
  ) -> T): Query<T> = SelectLastAnswersQuery(skill_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getLong(2)!!
    )
  }

  public fun selectLastAnswers(skill_id: String): Query<SelectLastAnswers> =
      selectLastAnswers(skill_id) { conversation_id, content, created_at ->
    SelectLastAnswers(
      conversation_id,
      content,
      created_at
    )
  }

  public fun countByConversation(conversation_id: String): Query<Long> =
      CountByConversationQuery(conversation_id) { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> selectNone(mapper: (
    id: String,
    conversation_id: String,
    role: String,
    content: String,
    sources: String?,
    status: String,
    error_code: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(325_028_535, arrayOf("assistant_message"), driver,
      "AssistantMessage.sq", "selectNone",
      "SELECT assistant_message.id, assistant_message.conversation_id, assistant_message.role, assistant_message.content, assistant_message.sources, assistant_message.status, assistant_message.error_code, assistant_message.created_at, assistant_message.updated_at, assistant_message.is_deleted, assistant_message.deleted_at, assistant_message.synced_at FROM assistant_message WHERE 0") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectNone(): Query<Assistant_message> = selectNone { id, conversation_id, role,
      content, sources, status, error_code, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Assistant_message(
      id,
      conversation_id,
      role,
      content,
      sources,
      status,
      error_code,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    conversation_id: String,
    role: String,
    content: String,
    sources: String?,
    status: String,
    error_code: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getString(5)!!,
      cursor.getString(6),
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9)!!,
      cursor.getLong(10),
      cursor.getLong(11)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Assistant_message> = selectByIdAnyState(id) {
      id_, conversation_id, role, content, sources, status, error_code, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Assistant_message(
      id_,
      conversation_id,
      role,
      content,
      sources,
      status,
      error_code,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insertFromRemote(
    id: String,
    conversation_id: String,
    role: String,
    content: String,
    sources: String?,
    status: String,
    error_code: String?,
    created_at: Long,
    updated_at: Long,
    synced_at: Long?,
  ) {
    driver.execute(1_902_533_196, """
        |INSERT INTO assistant_message(id, conversation_id, role, content, sources, status, error_code, created_at, updated_at, synced_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 10) {
          bindString(0, id)
          bindString(1, conversation_id)
          bindString(2, role)
          bindString(3, content)
          bindString(4, sources)
          bindString(5, status)
          bindString(6, error_code)
          bindLong(7, created_at)
          bindLong(8, updated_at)
          bindLong(9, synced_at)
        }
    notifyQueries(1_902_533_196) { emit ->
      emit("assistant_message")
    }
  }

  public fun updateFromRemote(
    conversation_id: String,
    role: String,
    content: String,
    sources: String?,
    status: String,
    error_code: String?,
    updated_at: Long,
    synced_at: Long?,
    id: String,
  ) {
    driver.execute(400_915_548, """
        |UPDATE assistant_message
        |SET conversation_id = ?, role = ?, content = ?, sources = ?, status = ?, error_code = ?, updated_at = ?, synced_at = ?
        |WHERE id = ?
        """.trimMargin(), 9) {
          bindString(0, conversation_id)
          bindString(1, role)
          bindString(2, content)
          bindString(3, sources)
          bindString(4, status)
          bindString(5, error_code)
          bindLong(6, updated_at)
          bindLong(7, synced_at)
          bindString(8, id)
        }
    notifyQueries(400_915_548) { emit ->
      emit("assistant_message")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    synced_at: Long?,
    id: String,
  ) {
    driver.execute(1_385_574_104,
        """UPDATE assistant_message SET is_deleted = 1, deleted_at = ?, updated_at = ?, synced_at = ? WHERE id = ?""",
        4) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindLong(2, synced_at)
          bindString(3, id)
        }
    notifyQueries(1_385_574_104) { emit ->
      emit("assistant_message")
    }
  }

  public fun restore(
    updated_at: Long,
    synced_at: Long?,
    id: String,
  ) {
    driver.execute(-2_067_376_885,
        """UPDATE assistant_message SET is_deleted = 0, deleted_at = NULL, updated_at = ?, synced_at = ? WHERE id = ?""",
        3) {
          bindLong(0, updated_at)
          bindLong(1, synced_at)
          bindString(2, id)
        }
    notifyQueries(-2_067_376_885) { emit ->
      emit("assistant_message")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-1_706_499_574,
        """UPDATE assistant_message SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-1_706_499_574) { emit ->
      emit("assistant_message")
    }
  }

  private inner class SelectByConversationQuery<out T : Any>(
    public val conversation_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("assistant_message", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("assistant_message", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_149_844_281,
        """SELECT assistant_message.id, assistant_message.conversation_id, assistant_message.role, assistant_message.content, assistant_message.sources, assistant_message.status, assistant_message.error_code, assistant_message.created_at, assistant_message.updated_at, assistant_message.is_deleted, assistant_message.deleted_at, assistant_message.synced_at FROM assistant_message WHERE conversation_id = ? AND is_deleted = 0 ORDER BY created_at, id""",
        mapper, 1) {
      bindString(0, conversation_id)
    }

    override fun toString(): String = "AssistantMessage.sq:selectByConversation"
  }

  private inner class SelectLastAnswersQuery<out T : Any>(
    public val skill_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("assistant_message", "assistant_conversation", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("assistant_message", "assistant_conversation", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(2_119_749_792, """
    |SELECT m.conversation_id, m.content, m.created_at FROM assistant_message m
    |JOIN assistant_conversation c ON c.id = m.conversation_id
    |WHERE c.skill_id = ? AND m.is_deleted = 0 AND m.role = 'assistant'
    |  AND m.created_at = (SELECT max(created_at) FROM assistant_message x
    |                      WHERE x.conversation_id = m.conversation_id AND x.is_deleted = 0 AND x.role = 'assistant')
    """.trimMargin(), mapper, 1) {
      bindString(0, skill_id)
    }

    override fun toString(): String = "AssistantMessage.sq:selectLastAnswers"
  }

  private inner class CountByConversationQuery<out T : Any>(
    public val conversation_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("assistant_message", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("assistant_message", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-2_063_026_074,
        """SELECT count(*) FROM assistant_message WHERE conversation_id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, conversation_id)
    }

    override fun toString(): String = "AssistantMessage.sq:countByConversation"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("assistant_message", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("assistant_message", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_523_160_970,
        """SELECT assistant_message.id, assistant_message.conversation_id, assistant_message.role, assistant_message.content, assistant_message.sources, assistant_message.status, assistant_message.error_code, assistant_message.created_at, assistant_message.updated_at, assistant_message.is_deleted, assistant_message.deleted_at, assistant_message.synced_at FROM assistant_message WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "AssistantMessage.sq:selectByIdAnyState"
  }
}
